import { render, staticRenderFns } from "./addExamineStaffList.vue?vue&type=template&id=5508731c&scoped=true"
import script from "./addExamineStaffList.vue?vue&type=script&lang=js"
export * from "./addExamineStaffList.vue?vue&type=script&lang=js"
import style0 from "./addExamineStaffList.vue?vue&type=style&index=0&id=5508731c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508731c",
  null
  
)

export default component.exports